<template>
  <breadcrumbs-component :breadCrumbs="adminBreadCrumbs"/>
  <div class="flex flex-row">
    <button class="round-button"
            :disabled="isLoading"
            :class="{selected: state === 'schemas'}"
            @click="getSchemas">
      Schemas
    </button>
    <button class="round-button"
            :disabled="isLoading"
            :class="{selected: state === 'assessments'}"
            @click="getAssessments">
      Assessments
    </button>
    <button class="round-button"
            :disabled="isLoading"
            :class="{selected: state === 'config'}"
            @click="getConfig">
      Config
    </button>
    <button class="round-button"
            :disabled="isLoading"
            :class="{selected: state === 'content'}"
            @click="getContent">
      Content
    </button>
    <button class="round-button"
            :disabled="isLoading"
            :class="{selected: state === 'user'}"
            @click="getUser">
      User
    </button>
    <button class="round-button"
            :disabled="isLoading"
            :class="{selected: state === 'task'}"
            @click="getTask">
      Task
    </button>
  </div>
  <div class="mt-5 h-[800px] w-[1200px]">
    <div ref="container" class="w-full h-full"></div>
  </div>
  <div class="flex relative box-border my-12 mx-0">
    <button class="btn" :disabled="isLoading" id="btn_safeUser" @click.prevent="save">
      Save
    </button>
  </div>
</template>

<script>
// TODO TRANSLATE EVERYTHING
import BreadcrumbsComponent from '@/components/Home/Shared/BreadcrumbsComponent.vue';
// eslint-disable-next-line import/extensions
import * as monaco from 'monaco-editor';
import NetworkAdmin from '@/helpers/networking/NetworkAdmin';

export default {
  name: 'AdminComponent',
  components: { BreadcrumbsComponent },
  data() {
    return {
      state: null,
      isLoading: false,
      initContent: '',
      initData: null,
      latestDbContent: null,
      adminBreadCrumbs: [
        {
          route: '/admin',
          isActive: true,
          label: this.$t('BreadCrumbs.admin'),
        },
      ],
    };
  },
  methods: {
    async getSchemas() {
      try {
        this.isLoading = true;
        const { data } = await NetworkAdmin.getAdminAssessmentSchemas();
        this.isLoading = false;
        this.initEditor(data.data, 'schemas');
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async getAssessments() {
      try {
        this.isLoading = true;
        const { data } = await NetworkAdmin.getAdminAssessment();
        this.isLoading = false;
        this.initEditor(data.data, 'assessments');
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async getConfig() {
      try {
        this.isLoading = true;
        const { data } = await NetworkAdmin.getAdminConfigElement();
        this.isLoading = false;
        this.initEditor(data.data, 'config');
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async getContent() {
      try {
        this.isLoading = true;
        const { data } = await NetworkAdmin.getAdminContentElement();
        this.isLoading = false;
        this.initEditor(data.data, 'content');
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async getUser() {
      try {
        this.isLoading = true;
        const { data } = await NetworkAdmin.getAdminUserElements();
        this.isLoading = false;
        this.initEditor(data.data, 'user');
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async getTask() {
      try {
        this.isLoading = true;
        const { data } = await NetworkAdmin.getAdminTaskElements();
        this.isLoading = false;
        this.initEditor(data.data, 'task');
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    initEditor(json, state) {
      const initData = JSON.stringify(json, null, '\t');
      this.editor.setValue(initData);
      this.initContent = initData;
      this.initData = json;
      this.state = state;
    },
    async saveSchemas() {
      try {
        const data = JSON.parse(this.editor.getValue());
        this.isLoading = true;
        await NetworkAdmin.saveAdminAssessmentSchemas(data);
        this.isLoading = false;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async saveAssessments() {
      try {
        const data = JSON.parse(this.editor.getValue());
        this.isLoading = true;
        await NetworkAdmin.saveAdminAssessment(data);
        this.isLoading = false;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async saveConfig() {
      try {
        const data = JSON.parse(this.editor.getValue());
        this.isLoading = true;
        await NetworkAdmin.saveAdminConfigElement(data);
        this.isLoading = false;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async saveContent() {
      try {
        const data = JSON.parse(this.editor.getValue());
        this.isLoading = true;
        await NetworkAdmin.saveAdminContentElement(data);
        this.isLoading = false;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async saveUser() {
      try {
        const data = JSON.parse(this.editor.getValue());
        this.isLoading = true;
        await NetworkAdmin.saveAdminUserElements(data);
        this.isLoading = false;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async saveTask() {
      try {
        const data = JSON.parse(this.editor.getValue());
        this.isLoading = true;
        await NetworkAdmin.saveAdminTaskElements(data);
        this.isLoading = false;
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    async save() {
      if (this.hasErrors()) {
        alert('Content has Errors');
        return;
      }

      if (!this.hasChanges()) {
        alert('No Changes');
        return;
      }

      this.isLoading = true;
      const hasChange = await this.hasChangesInDB();
      this.isLoading = false;
      if (hasChange) {
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('The database data has been changed do you want to continue?')) {
          return;
        }
      }

      try {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('Are you sure you want to submit these changes?')) {
          this.isLoading = true;
          await this.callSavedMethod();
          this.$toast.add({
            severity: 'success',
            summary: 'Changes saved!',
            detail: '',
            life: 3000,
          });
          await this.callGetInitMethod();
          this.isLoading = false;
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
      }
    },
    hasChanges() {
      return this.initContent !== this.editor.getValue();
    },
    hasErrors() {
      const errors = monaco.editor.getModelMarkers({ resource: this.editor });
      return errors.length !== 0;
    },
    async hasChangesInDB() {
      try {
        this.isLoading = true;
        await this.callGetForLatestDbDataMethod();
        this.isLoading = false;
        return JSON.stringify(this.initData) !== JSON.stringify(this.latestDbContent);
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error! Check console output!',
          detail: '',
          life: 3000,
        });
        console.log(error);
        this.isLoading = false;
        return true;
      }
    },
    async callSavedMethod() {
      // eslint-disable-next-line default-case
      switch (this.state) {
        case 'schemas':
          await this.saveSchemas();
          break;
        case 'assessments':
          await this.saveAssessments();
          break;
        case 'config':
          await this.saveConfig();
          break;
        case 'content':
          await this.saveContent();
          break;
        case 'user':
          await this.saveUser();
          break;
        case 'task':
          await this.saveTask();
          break;
      }
    },
    async callGetInitMethod() {
      // eslint-disable-next-line default-case
      switch (this.state) {
        case 'schemas':
          await this.getSchemas();
          break;
        case 'assessments':
          await this.getAssessments();
          break;
        case 'config':
          await this.getConfig();
          break;
        case 'content':
          await this.getContent();
          break;
        case 'user':
          await this.getUser();
          break;
        case 'task':
          await this.getTask();
          break;
      }
    },
    async callGetForLatestDbDataMethod() {
      // eslint-disable-next-line default-case
      let data;
      switch (this.state) {
        case 'schemas':
          ({ data } = await NetworkAdmin.getAdminAssessmentSchemas());
          this.latestDbContent = data.data;
          break;
        case 'assessments':
          ({ data } = await NetworkAdmin.getAdminAssessment());
          this.latestDbContent = data.data;
          break;
        case 'config':
          ({ data } = await NetworkAdmin.getAdminConfigElement());
          this.latestDbContent = data.data;
          break;
        case 'content':
          ({ data } = await NetworkAdmin.getAdminContentElement());
          this.latestDbContent = data.data;
          break;
        case 'user':
          ({ data } = await NetworkAdmin.getAdminUserElements());
          this.latestDbContent = data.data;
          break;
        case 'task':
          ({ data } = await NetworkAdmin.getAdminTaskElements());
          this.latestDbContent = data.data;
          break;
        default:
          console.log('Unkown State!');
      }
    },
  },
  mounted() {
    this.editor = monaco.editor.create(this.$refs.container, {
      value: this.code,
      language: 'json',
      theme: 'vs-dark',
    });
  },
  unmounted() {
    this.editor.dispose();
  },
};
</script>

<style scoped>
.round-button, .btn {
  @apply rounded-3xl bg-[var(--color-bisque)] py-3 px-5 mr-3 hover:bg-[var(--color-fulvous)]
}

.btn {
  @apply px-10;
}

.round-button.selected {
  background-color: var(--color-fulvous);
}
</style>
